<template>
	<div>
		<el-dialog
			title="回收确认"
			:visible.sync="dialogVisible"
			width="500px"
		>
			<span>{{ msgTip }}</span>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirmBtnFun">确 认</el-button>
        <el-button @click="cancelBtnFun">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false,
      typeNum: 1, // 单条回收 | 多条回收
    }
  },
  computed: {
    msgTip () {
      return this.typeNum == 1? '确认创建回收单？' : '确认批量创建回收单？'
    }
  },
  methods: {
    // 打开弹框
    opendDialog () {
      this.dialogVisible = true
    },
    // 取消弹框
    cancelBtnFun () {
      this.dialogVisible = false
    },
    // 确认
    confirmBtnFun () {
      this.$emit('confirm-recycle')
      this.dialogVisible = false
    }
  },
}
</script>
<style scoped lang="scss">
.dialog-footer{
  padding: 16px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/components/RecycleConfirmDialog.vue